/** Validate an object is a valid JS number */
export function isNumber(object: any): object is number {
  return !isNaN(parseFloat(object)) && isFinite(object);
}
